module.exports = __webpack_public_path__ + "static/media/linkedin.d8ea3969.png";